export enum StreamingSortByEnum {
	STREAMING_NAME = "STREAMING_NAME",
	DESCRIPTION = "DESCRIPTION",
	CREATED = "CREATED",
	UPDATED = "UPDATED",
	STATUS = "STATUS",
	DATASET_NAME = "DATASET_NAME",
}
